<template>
	<Loading :loading="loading || wpLoading" class="">
		<div class="col-12 col-md-8">
			<WordpressContentPage
				pageSlug="complete-profile-top"
				class="col-12"
				:showLoading="false"
				v-on:loaded="wpContentLoaded"
			/>
			<form v-if="preferences" v-on:submit.prevent="submitForm">
				<h3>I'm interested in:</h3>
				<!-- Preferences Form -->
				<div class="form-group row">
					<div v-for="pref of prefOptions" :key="pref.id" class="col-12 col-lg-6">
						<label class="form-check-label">
							<input 
								v-model="vModelPrefs[pref.id-1]"
								type="checkbox"
								class="preferences-check-input"
							>
							<span v-if="pref.name == 'Home Decor'">Home D{{'&eacute;'}}cor</span>
							<span v-else>{{pref.name}}</span>
						</label>  
					</div>
				</div>
				<!-- End Preferences Form -->

				<!-- Address Fields -->
				<div class="form-group row">
					<h3 class="col-12">Delivery Details:</h3>
					<label class="col-sm-5">Street*</label>
					<input
						type="text"
						v-model="memberDetails.delivery_street_address"
						name="Delivery Street Address"
						class="col-sm-7 form-control"
						v-validate="'required'"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery Street Address')}}</div>

					<label class="col-sm-5">Suburb</label>
					<input type="text" v-model="memberDetails.delivery_suburb" class="col-sm-7 form-control" name="Delivery Suburb">
					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery Suburb')}}</div>

					<label class="col-sm-5">City*</label>
					<input type="text" v-model="memberDetails.delivery_city" class="col-sm-7 form-control" v-validate="'required'" name="Delivery City">
					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery City')}}</div>

					<label class="col-sm-5">Post Code*</label>
					<input
						type="text"
						v-model="memberDetails.delivery_postcode"
						v-validate="{required:true, regex: /^\d{4}$/}"
						name="Delivery Postcode"
						class="col-sm-7 form-control"
					>

					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery Postcode')}}</div>

					<label class="col-sm-5 col-form-label">Preferred Contact Number</label>
					<input
						type="text"
						v-model="memberDetails.prefered_contact_number"
						class="col-sm-7 form-control"
						name="preferred_contact_number"
						v-validate="{regex:/^([+]?[0-9 ]+)$/}"
						data-vv-as="Preferred Contact Number"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.preferred_contact_number')}}</div>

					<label class="col-sm-5">Delivery Instructions</label>
					<textarea
						rows="3"
						v-model="memberDetails.delivery_instructions"
						class="col-sm-7 form-control"
					/>

					<div class="form-check-inline col-12">
						<div class="col-0 col-md-5"></div>
						<div class="col-md-7 col-12">
						<label class="form-check-label">
							<input type="checkbox" v-model="billingSameAsDelivery" class="form-check-input">
							Billing & delivery address same
						<h2></h2></label>
						</div>
					</div>
				</div>
				<div v-if="billingSameAsDelivery === false" class="form-group row">
					<h3 class="col-12">Billing Details:</h3>

					<label class="col-sm-5">Street*</label>
					<input
						type="text"
						v-model="memberDetails.billing_street_address"
						class="col-sm-7 form-control"
						v-validate="'required'"
						name="Billing Street Address"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.Billing Street Address')}}</div>


					<label class="col-sm-5">Suburb</label>
					<input type="text" v-model="memberDetails.billing_suburb" class="col-sm-7 form-control" name="Billing Suburb">
					<div class="invalid-feedback">{{errors.first('memberDetails.Billing Suburb')}}</div>



					<label class="col-sm-5">City*</label>
					<input type="text" v-model="memberDetails.billing_city" class="col-sm-7 form-control" v-validate="'required'" name="Billing City">

					<div class="invalid-feedback">{{errors.first('memberDetails.Billing City')}}</div>

					<label class="col-sm-5">Post Code*</label>
					<input type="text" v-model="memberDetails.billing_postcode" class="col-sm-7 form-control" v-validate="{required:true, regex: /^\d{4}$/}" name="Billing Postcode">
					<div class="invalid-feedback">{{errors.first('memberDetails.Billing Postcode')}}</div>

				</div>





				<div class="row justify-content-center">
					<router-link :to="{ name: 'home' }" class="btn btn-primary mx-3 btn-grey">Update Later</router-link>
					<ButtonWithLoading
						type="submit"
						class="btn btn-primary mx-3"
						text="Save"
						loadingText="Saving"
						successText="Saved"
						failureText="Error Saving"
						:state="submitState"
					/>
				</div>
				<div v-if="message" class="row justify-content-center">
					<div class="alert alert-danger col-auto">
						{{message}}
					</div>
				</div>
			</form>
		</div>
	</Loading>
</template>

<script>

import { fetchUserDetails, saveUserDetails, fetchPreferenceOptions, savePreferences  } from "@/network/userRequests";
import Loading from "@/components/loading/Loading";
import ButtonWithLoading from "@/components/buttonWithLoading";
import WordpressContentPage from "@/wordpress/WordpressContentPage";
import { mapState } from "vuex";


export default {
	name: 'Preferences',
	components: {
		Loading,
		ButtonWithLoading,
		WordpressContentPage,
	},
	data() {
		return {
			user: null,
			loading: false,
			submitState: null,
			prefOptions: null,
			vModelPrefs: null,
			billingSameAsDelivery: null,
			message: "",
			wpLoading: true,
		};
	},
	created() {
		if (this.last_logged_in != "0000-00-00 00:00:00") {
			this.$router.replace({ name: "account" })
		}
		this.getData();
	},
	methods: {
		getData() {
			this.loading = true;
			fetchUserDetails(userDetails => {
				this.user = userDetails;
				//check if billing and delivery address are the same
				this.billingSameAsDelivery = this.addressesMatch(userDetails);
				// Extract the check state of the preferences for use with Vmodel
				this.vModelPrefs = []
				for (let pref of this.user.preferences) {
					if (pref != undefined) {
						this.vModelPrefs[parseInt(pref.preference_id_fk) - 1] = pref.selected
					}
				}
				fetchPreferenceOptions(  // Means the global list always shows regardless of whether the user has the most up to date one
					(prefs) => {
						this.loading = false;
						this.prefOptions = prefs;
						for (let pref of prefs) {
							if (this.vModelPrefs[parseInt(pref.id) - 1] == undefined) {
								this.vModelPrefs[parseInt(pref.id) - 1] = false;
							}
						}
					}
				)
			});
		},
		wpContentLoaded() {
			this.wpLoading = false;	
		},
		addressesMatch() {
			const {
				delivery_street_address,
				delivery_city,
				delivery_postcode,
				delivery_suburb,
				billing_street_address,
				billing_city,
				billing_postcode,
				billing_suburb
			} = this.user.member_details;

			return (
				delivery_street_address === billing_street_address &&
				delivery_suburb === billing_suburb &&
				delivery_city === billing_city &&
				delivery_postcode === billing_postcode
			);
		},
		setBillingAddressToDelivery() {
			var {
				delivery_street_address,
				delivery_city,
				delivery_postcode,
				delivery_suburb
			} = this.user.member_details;

			this.user.member_details.billing_street_address = delivery_street_address;
			this.user.member_details.billing_suburb = delivery_suburb;
			this.user.member_details.billing_city = delivery_city;
			this.user.member_details.billing_postcode = delivery_postcode;
		},
		savePreferencesData() {
			let preferences = []
			for (let pref of this.prefOptions) {
				let temp = {};
				temp.preferences_id_fk = pref.id
				temp.selected = this.vModelPrefs[parseInt(pref.id) - 1]
				preferences.push(temp)
			}

			savePreferences(
				{ preferences: preferences},
				(response) => {
					if(response.success) {
						this.submitState = "success";
						this.message = null;
						setTimeout(() => {
							this.submitState = null;
							this.$router.replace({ name: "home" });
						}, 1000);
					} else {
						this.submitState = "failure";
						this.message = response.error
						setTimeout(() => {
							this.submitState = null;
						}, 1000);
					}
				},
				() => {
					this.submitState = "failure";
					this.message = "Error Saving Preferences"
					setTimeout(() => {
						this.submitState = null;
					}, 1000);
				}
			)
		},
		submitForm() {

			this.$validator.validateAll("memberDetails").then(valid => {
				if (!valid) return;
				this.submitState = "loading";
				//set billing same as delivery before backend request if box ticked
				if (this.billingSameAsDelivery) this.setBillingAddressToDelivery();
				saveUserDetails(
					{ memberDetails: this.user.member_details },
					(response) => {
						if(response.success){
							this.errors.clear();
							this.$validator.reset();
							this.message = null
							this.savePreferencesData();  //Save the data 
						}else{
							this.submitState = "failure";
							this.message = response.error;
							this.errors.clear();
							this.$validlast_logged_inator.reset();
							setTimeout(() => {
								this.submitState = null;
							}, 1000);
						}
					},
					() => {
						//failure saving user details
						this.submitState = "failure";
						this.message = "Error saving details";
						setTimeout(() => {
							this.submitState = null;
						}, 1000);
					}
				);
			});
		},
	},
	computed: {
		...mapState({
			last_logged_in: state => state.member.last_logged_in
		}),
		preferences() {
			if(this.user && this.user.preferences) {
				return this.user.preferences;
			}
			return null;
		},
		memberDetails() {
			if (this.user && this.user.member_details) {
				let details = this.user.member_details
				if (details.home_phone==null || details.home_phone==undefined){
					details.home_phone=''
				}
				if (details.cellphone==null || details.cellphone==undefined){
					details.cellphone=''
				}
				if (details.preferred_contact_number==null || details.preferred_contact_number==undefined){
					details.preferred_contact_number=''
				}
				return details;
			}
			return null;
		},
	}
}
</script>

<style lang="scss" scoped>
	.preferences-check-input {
		position: static;
		margin-top: 0;
		margin-right: 0.3125rem;
		margin-left: 0;
	}
</style>
